export default function parseUrl(url) {
  const parser = document.createElement('a');
  parser.href = url;

  // url.origin is not supported in IE and buggy for ws:// urls in Edge
  // that's why we need to create our own origin from protocol and host
  const origin = parser.protocol + '//' + parser.host;
  let pathname = parser.pathname;

  // IE fix for pathname resolution
  if (pathname.substring(0, 1) !== '/') {
    pathname = '/' + pathname;
  }

  return { origin, pathname };
}
